import React from 'react';

export default function GarageMembershipTag() {
  return <div className="GarageMembershipTag">Garage Membership Booking</div>;
}
